import * as React from 'react';
import { createContext, useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';

export type InviteToApplyContextType = {
  showInviteToApplyModal: boolean;
  setShowInviteToApplyModal: Dispatch<SetStateAction<boolean>> | (() => false);
};

export const InviteToApplyContext = createContext<InviteToApplyContextType>({
  showInviteToApplyModal: false,
  setShowInviteToApplyModal: () => false,
});

type PropsFromCaller = {
  children: React.ReactNode;
};

export const InviteToApplyProvider = ({ children }: PropsFromCaller) => {
  const [showInviteToApplyModal, setShowInviteToApplyModal] = useState<boolean>(false);

  return (
    <InviteToApplyContext.Provider
      value={{
        showInviteToApplyModal,
        setShowInviteToApplyModal,
      }}
    >
      {children}
    </InviteToApplyContext.Provider>
  );
};
